import Vue from 'vue'

export const USER_SIGNIN = 'USER_SIGNIN';
export const USER_SIGNOUT = 'USER_SIGNOUT';

export default {
    state: {
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : '',
        userId: localStorage.getItem("userId") || ''
    },
    mutations: {
        [USER_SIGNIN](state, user){
            console.log(user, '222');
            localStorage.setItem('user', JSON.stringify(user));
            Object.assign(state, {user});
        },
        [USER_SIGNOUT](state){
            localStorage.removeItem('user');
            Object.keys(state).forEach(k => Vue.delete(state, k));
        },
        setUserId(state, aid) {
            localStorage.setItem('userId', aid)
            state.userId = aid || ''
        }
    },
    actions: {
        [USER_SIGNIN]({commit}, user){
            commit(USER_SIGNIN, user);
        },
        [USER_SIGNOUT]({commit}, user){
            commit(USER_SIGNOUT, user);
        },
    }
}